import React, { Component } from "react";
import { dispatch } from "@rematch/core";
import { systemNotificationService } from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";

const initialState = {
  allSystemNotificationList: null,
  systemNotificationById: null,
};

export default {
  state: initialState,
  reducers: {
    setSystemNotification(state, payload) {
      return {
        ...state,
        allSystemNotificationList: payload,
      };
    },
    setSystemNotificationById(state, payload) {
      return {
        ...state,
        systemNotificationById: payload,
      };
    },

    clear() {
      return initialState;
    },
  },

  effects: {
    clearAsync() {
      //  dispatch.systemnotification.clear();
    },
    async getSystemNotification(payload, state) {
      try {
        // let payloadObject = {
        //     "accountId": state.app.selectedAccount._id,
        //     "organizationId": state.app.selectedOrganisation._id,
        // }
        const query = {
          isPublic: true,
        };
        let foundData = await systemNotificationService.find({ query: query });
        await dispatch.systemNotification.setSystemNotification(foundData);
      } catch (error) {
        throw error;
      }
    },

    async createSystemNotification(payload, state) {
      try {
        // payload.accountId = state.app.selectedAccount._id
        //  console.log("Acc ID", state.app.selectedAccount._id)
        // payload.organizationId = state.app.selectedOrganisation._id
        //  console.log("Org ID", state.app.selectedOrganisation._id)
        let createdSystemNotification = await systemNotificationService.create(
          payload
        );
        await dispatch.systemNotification.getSystemNotification();
      } catch (error) {
        throw error;
      }
    },

    // changes made for KLM-8917 KLM-8921
    async editSystemNotification(payload, state) {
      try {
        const params = {
          query: {
            isPublic: true,
          },
        };
        let editedSystemNotification = await systemNotificationService.patch(
          payload._id,
          {
            title: payload.title,
            description: payload.description,
            expDate: payload.expDate,
          },
          params
        );
        await dispatch.systemNotification.setSystemNotificationById(
          editedSystemNotification
        );
      } catch (error) {
        throw error;
      }
    },

    async deleteSystemNotification(payload, state) {
      try {
        const query = {
          isPublic: true,
        };
        await systemNotificationService.remove(payload._id, { query });
        await dispatch.systemNotification.getSystemNotification();
      } catch (error) {
        throw error;
      }
    },

    // async deleteSystemNotification(payload) {
    //     try {

    //         await systemNotificationService.remove(payload.categoryId);
    //         await dispatch.account.setSelectedSystemNotificationAsync({})

    //         let data = { "accountId": payload.accountId }
    //         if (!payload.organizationId) {
    //             data.accountOnly = true
    //         }
    //         await dispatch.lifeCycle.getSystemNotificationTreeAsync(data);
    //         if (payload.levelDepth === 'baseSystemNotification') {
    //             await dispatch.lifeCycle.getSystemNotificationTreeAsync(data);
    //         }
    //         else if (payload.levelDepth === 'category') {
    //             await dispatch.lifeCycle.getSystemNotificationTreeAsync(data);
    //             await dispatch.account.setIsSystemNotificationChange(true);
    //         }
    //         else if (payload.levelDepth === 'subSystemNotification') {
    //             await dispatch.account.setIsSystemNotificationChange(true);
    //         }

    //     }
    //     catch (error) {
    //         throw error;
    //     }
    // },
    makeDefault(payload) {
      //    defaultSystemNotificationService.create(payload);
    },
    socketRefresh(data, state) {
      // let list = state.systemNotification.systemNotificationById
      // let setName = data.isKb ? "Knowledge Bank" :
      //     data.isSystemNotification ? "SystemNotification" :
      //         data.isSubSystemNotification ? "Sub SystemNotification" : "SystemNotification"
      // if (data.socketAction === "patched") {
      //     if (list && list.length !== 0) {
      //         for (let i = 0; i < list.length; i++) {
      //             if (list[i]._id === data._id) {
      //                 list[i] = data;
      //                 data.actionTypeMsg = "updated successfully."
      //                 toastr.success('Message', setName + " updated successfully.")
      //             }
      //         }
      //     }
      // } else if (data.socketAction === "create" || data.socketAction === "categoryCopied") {
      //     if ((data.organizationId && data.organizationId === state.app.selectedOrganisation._id) ||
      //         (!data.organizationId && data.accountId === state.app.selectedAccount._id)) {
      //         list && list.push(data)
      //         toastr.success('Message', setName + " created successfully.")
      //     }
      // } else if (data.socketAction === "removed") {
      //     if (list && list.length !== 0) {
      //         for (let i = 0; i < list.length; i++) {
      //             if (list[i]._id === data._id) {
      //                 list.splice(i, 1);
      //                 toastr.success('Message', setName + " deleted successfully.")
      //             }
      //         }
      //     }
      // }
      // var collator = new Intl.Collator(undefined, {
      //     numeric: true,
      //     sensitivity: 'base'
      // });
      // list && list.sort((a, b) => {
      //     return collator.compare(a.name, b.name)
      // })
      // dispatch.systemNotification.setSystemNotificationById(list)
      // dispatch.systemNotification.getAllSystemNotification()
    },
  },
};
